import { WidgetFormSubmissionWithWidget } from "@closerplatform/spinner-openapi";
import { isContactEnquiryConfigContext } from "@fidget/common/models/shared/spinner/types/messageWidgets/WidgetFormSubmissionWithWidget";
import { UserAnswers } from "../types";
import { ContactEnquiryInputs } from "./contactEnquiryFormUtils";

export const prepareAnswersForSubmit = (
  submission: WidgetFormSubmissionWithWidget,
  answers: UserAnswers,
  phoneRegion: string
): UserAnswers => {
  if (isContactEnquiryConfigContext(submission.widgetConfig)) {
    const { [ContactEnquiryInputs.Contact]: obj, ...rest } = answers;
    const value = obj!.value;
    if (value && !value.includes("@")) {
      // todo use libphonenumber-js
      const phonePrefix = phoneRegion === "ZZ" ? "" : "";
      return {
        [ContactEnquiryInputs.Contact]: {
          inputName: ContactEnquiryInputs.Contact,
          value: phonePrefix + value
        },
        ...rest
      };
    }
  }

  return answers;
};
